import { PAYMENT_MODES } from "constants/paymentModes";
import { logger } from "logging";

/**
 * @description callback function to update request header
 * Currently, it is being used for adding "request-startTime"
 * in the API request headers.
 * @param req {AxiosRequestConfig}
 * @returns AxiosRequestConfig
 */
 export const setRequestHeader = (req: any) => {
    try {
      req.headers["request-startTime"] = new Date().getTime();
      return req;
    } catch (error) {
      logger.error(error as Error, "Error while setting the request header");
      return req;
    }
};

  /**
   * This function is to identify if only QR Code is available and UPI collect is disabled.
   * since, QR is powered by UPI intent, and shown inside UPI collect.
   * This case is handled separately to open UPI intent screen directly.
   * NOTE: This function is used only in desktop flow.
   */
  export const isOnlyQrAvailable = (availablePaymentMethods: any, isQRCodeAvailable: boolean) => {
    const isUpiCollectPresent = availablePaymentMethods?.includes(PAYMENT_MODES.UPI);
    const isUpiIntentPresent = availablePaymentMethods?.includes(PAYMENT_MODES.GOOGLE_PAY);
    if (isUpiIntentPresent && !isUpiCollectPresent && isQRCodeAvailable) {
      return true;
    }
    return false;
  };

  /**
   * This function is to identify if only UPI intent is available and UPI collect is disabled.
   * @param availablePaymentMethods - available payment methods
   * @returns {boolean} whether only UPI intent is available or not
   */
  export const isOnlyUpiIntentAvailable = (availablePaymentMethods: any) => {
    const isUpiCollectPresent = availablePaymentMethods?.includes(PAYMENT_MODES.UPI);
    const isUpiIntentPresent = availablePaymentMethods?.includes(PAYMENT_MODES.GOOGLE_PAY);
    if (isUpiIntentPresent && !isUpiCollectPresent) {
      return true;
    }
    return false;
  };
